/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Typography } from '@astro-ui/components'

type InventoryStatusConfigType = {
  textColor: string
  bgColor: string
  borderColor: string
}

type StatusValueEnum = 'SUCCESS' | 'DANGER'

export const STATUS_CONFIG: Record<StatusValueEnum, InventoryStatusConfigType> = {
  SUCCESS: {
    textColor: '#00552E',
    bgColor: '#E6F7EF',
    borderColor: '#CCEEDE',
  },
  DANGER: {
    textColor: '#611919',
    bgColor: '#F9E6E6',
    borderColor: '#F2CCCC',
  },
}

type StatusChipPropsType = {
  label: string
  status: StatusValueEnum
}

const InventoryStatusChip = ({ label, status }: StatusChipPropsType) => {
  if (!status) return null

  const config = STATUS_CONFIG?.[status.replace('_', ' ') as StatusValueEnum] || {
    textColor: '#646464',
    bgColor: '#F4F4F4',
    borderColor: '#E0E0E0',
  }

  const backgroundColor = config.bgColor
  const { textColor } = config
  const { borderColor } = config

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      px="12px"
      py="4px"
      borderRadius="32px"
      border="1px solid"
      borderColor={borderColor}
      bg={backgroundColor}
    >
      <Typography variant="body-smallStrong" sx={{ color: textColor }} whiteSpace="nowrap">
        {label}
      </Typography>
    </Box>
  )
}

export default InventoryStatusChip
